import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 40px;

  a {
    width: 120px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    color: #000;
    font-size: 18px;
    border-bottom: 3px solid #656565;
    margin: 20px;
    transition: 0.2s ease-in-out;

    &:hover {
      color: #b566ff;
      border-bottom: 3px solid #b566ff;
    }
  }

  @media (max-width: 1180px) {
  }

  @media (max-width: 768px) {
    h1 {
      width: 600px;
    }
  }

  /* regular phones and below */
  @media (max-width: 480px) {
    h1 {
      width: 400px;
      font-size: 24px;
    }
  }

  @media (max-width: 425px) {
    h1 {
      width: fit-content;
    }
  }
`;

export const WrapCaption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;

  h1 {
    text-align: center;
  }

  img {
    margin: 10px;
  }

  /* regular phones and below */
  @media (max-width: 424px) {
    h1 {
      font-size: 24px;
    }
  }
`;

export const WrapProject = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: center;
  margin: 0 40px 80px 40px;
 
  div {
    div {
      div {
        div {
          div {
            div {
              width: 100%;
              height: 100%;
              z-index: -1;
            }
          }
        }
      }
    }
  }
`;

export const Link = styled.a`
  text-decoration: none;
  color: #000;
`;

export const Project = styled.div`
  display: flex;

  div {

  }

`;